var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCreatorActiveGiveaway } from 'root/src/client/web/giveaway/hooks/useCreatorGiveaways';
import { useGiveawayApi } from 'root/src/client/web/giveaway/hooks/useGiveawayApi';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import { EntryFailureCode } from 'root/src/shared/giveaways/giveaways.constants';
import { OnlySubscribersModal } from 'root/src/client/web/giveaway/features/OnlySubscribersModal/OnlySubscribersModal';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import SignInWithProviderModal from 'root/src/client/web/auth/features/SignInWithProviderModal';
import { ScopeSet } from 'root/src/shared/@types/auth';
import toast from 'react-hot-toast';
import { getReadableProviderName } from 'root/src/client/v2/auth/helpers/providerHelpers';
export const useEnterGiveawayApi = () => {
    const giveaway = useCreatorActiveGiveaway();
    const giveawayApi = useGiveawayApi();
    const creatorDataApi = useCreatorDataApi();
    const modal = useModal();
    const enterGiveaway = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!giveaway || giveaway.isEntered)
            return;
        const { error } = yield giveawayApi.enterGiveaway({
            giveawayId: giveaway.id,
        });
        if (!error) {
            yield creatorDataApi.fetchGiveaways();
            return;
        }
        if (error.code === EntryFailureCode.NOT_CONNECTED_ACCOUNT) {
            const { props } = error;
            modal.show(<ConnectProviderModal provider={props.provider} label={props.label}/>);
            return;
        }
        if (error.code === 'ApiAuthError') {
            const { props } = error;
            modal.show(<RefreshProviderModal provider={props.provider}/>);
            return;
        }
        if (error.code === EntryFailureCode.ONLY_SUBSCRIBERS) {
            const { props } = error;
            modal.show(<OnlySubscribersModal profileURL={props.profileURL} platform={props.platform}/>);
            return;
        }
        if (error.code === EntryFailureCode.MAX_WINS_REACHED) {
            const { props } = error;
            const hours = Math.floor(props.limitResetIn / 3600);
            const ordinal = hours === 1 ? 'hour' : 'hours';
            toast.error(`You have reached today's win limit. Try again in ${hours} ${ordinal}`);
            return;
        }
        throw error;
    });
    return { enterGiveaway };
};
const ConnectProviderModal = ({ provider, label }) => {
    const modal = useModal();
    return (<ModalLayout>
			<SignInWithProviderModal props={{
            item: {
                provider,
                label,
                header: 'Connect Channel',
                isLinking: true,
                scopeSet: ScopeSet.viewer,
                popup: true,
                popupOptions: {
                    onSuccess: () => {
                        modal.hide();
                        toast.success('Account successfully linked!');
                    },
                    onError: (error) => {
                        console.error(error);
                        toast.error((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong!');
                    },
                },
            },
        }}/>
		</ModalLayout>);
};
const RefreshProviderModal = ({ provider }) => {
    const modal = useModal();
    return (<ModalLayout>
			<SignInWithProviderModal props={{
            item: {
                popup: true,
                popupOptions: {
                    onSuccess: () => {
                        modal.hide();
                        toast.success('Account successfully refreshed!');
                    },
                    onError: (error) => {
                        console.error(error);
                        toast.error((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong!');
                    },
                },
                provider,
                header: 'Sign in to continue',
                label: `Please re-authenticate your ${getReadableProviderName(provider)} account to join to this Giveaway.`,
            },
        }}/>
		</ModalLayout>);
};
